
import {map, onNotify, task} from 'nanostores';

import dataSchema from './Schema.jsx';
import * as C from '../controls/constraints.jsx'
import _ from 'lodash';

import { jsonOrFail } from './utils.jsx';
import { $productConfig } from './Config.jsx';


export const makeCleanState = () => C.mangleDataBySchema({}, dataSchema)
export const makeCleanFlags = () => ({
    isPristine: true,
    isModified: false,

    isLoaded: false,
    isLoadApproved: false,

    isError: false,
    lastError: null,

    isSent: false,
    sentUid: null,
})

export const $currentState = map(makeCleanState());

export const $currentFlags = map(makeCleanFlags());


export const markLoadApproved = () => {
    $currentFlags.setKey('isLoadApproved', true);
}


export const applyDiff = (diff) => {
    $currentFlags.setKey('isPristine', false);
    $currentFlags.setKey('isModified', true);

    const original = $currentState.get();

    _.forEach(diff, (v, k) => {
        _.set(original, k, v);
       });

    const modified = C.mangleDataBySchema(original, dataSchema)

    $currentState.set(modified);
}


export const resetState = () => {
    $currentState.set(makeCleanState());
    $currentFlags.set(makeCleanFlags());
}


export const clearSavedState = () => {
    resetState();

    const config = $productConfig.get();
    localStorage.removeItem(config.storage_data_key);
    localStorage.removeItem(config.storage_session_key);
}

export const loadState = (initial) => 
    task(async () => {
        const config = $productConfig.get();

        resetState();

        try {
            const storedData = localStorage.getItem(config.storage_data_key);
            if(!_.isNil(storedData) && !_.isEmpty(storedData)) {
                const storedObj = JSON.parse(storedData);
                if(!_.isNil(storedObj) && !_.isEmpty(storedObj)) {
                    $currentState.set(storedObj);
                    $currentFlags.setKey('isPristine', initial?true:false);
                    $currentFlags.setKey('isLoaded', true);
                    $currentFlags.setKey('isModified', false);
            
                }

            }

            console.log('loaded');

        } catch(e) {
            console.error(e) 

        }
});


export const saveState = () => 
    task(async () => {
        const config = $productConfig.get();
        const data = $currentState.get();

        const dataSer = JSON.stringify(data);
        localStorage.setItem(config.storage_data_key, dataSer);

        $currentFlags.setKey('isLoaded', false);
        $currentFlags.setKey('isModified', false);

        console.log('saved');
    });


export const postState = () =>
    task(async () => {
        const config = $productConfig.get();
        const data = $currentState.get();

        return fetch(config.post_url, {
            method:"POST",
            headers: {
                "Content-Type": "application/json;charset=UTF-8"
            },
            body: JSON.stringify(data)
        })
        .then(jsonOrFail)
        .then((rsp) => {
            $currentFlags.setKey('sentUid', rsp.statement_id)
            $currentFlags.setKey('isSent', true);

            console.log('posted', rsp.statement_id);
            return rsp.statement_id;

        })
        .catch((err) => {
            $currentFlags.setKey('isError', true);
            $currentFlags.setKey('lastError', err);
            throw err;
            
        });
    });


let saveTimer = null;

export const saveStateDeferred = (time) => {
    task(async () => {
        const config = $productConfig.get();

        if(saveTimer) clearTimeout(saveTimer);
        saveTimer = setTimeout(() => {
            saveState();

        }, time||config.storage_save_intvl);
    
    });
}


onNotify($currentState, ($) => {
    const flags = $currentFlags.get();
    if(!flags.isPristine) saveStateDeferred();
});
